export default "__VITE_ASSET__DD7Dk5dF__"